
import { PropType, defineComponent } from 'vue'

import Alert from '@/components/alert.vue'
import CheckIcon from '@/components/check-icon.vue'
import AlertModal from '@/components/alert-modal.vue'

export interface PreEnrollmentFormState {
  customContent?: boolean
  siteURL: string
  publish: boolean
  domainName: string
  urlError: string | null
  isUrlUnique: boolean | null
  isUrlValid: boolean
  isCheckingUrl: boolean
  shouldShowUrlCheck: boolean
  isOeUrlDisabled: boolean
  showUnpublishWarning: boolean
  isPublishDisabled: boolean
  isConfirmEditUrlModalOpen: boolean
  isPublishModalOpen: boolean
  isUnpublishModalOpen: boolean
  isPublishModalSuccess: boolean
  isUnpublishModalSuccess: boolean
  isConfirmRemoveCustomModalOpen: boolean
}

export default defineComponent({
  name: 'pre-enrollment-form',
  components: {
    CheckIcon,
    AlertModal,
    Alert
  },
  props: {
    preEnrollment: {
      type: Object as PropType<PreEnrollmentFormState>,
      required: true
    }
  }
})
